import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NimAuthApiClientService} from './auth-api-client.service';
import {INimLoginResponse, INimRegisterResponse, NIM_AUTH_ERRORS, NIM_AUTH_TYPE} from './auth.model';

@Component({
  selector: 'nim-webshare-auth-form',
  template: `
    <div class="auth-form"
        [ngClass]="{
          'm-viewtype-1': viewType === 1,
          'm-viewtype-2': viewType === 2,
          'auth-form__disabled': isDisabled,
          'auth-form__remove': authType === NIM_AUTH_TYPE.REMOVE
        }">
      <div class="auth-form-wrapper">
        <div class="auth-form-top">
          <div class="auth-form-logo" *ngIf="viewType === 2 && !isShowTabs && authType !== NIM_AUTH_TYPE.REMOVE">
            <img src="./dist/assets/fusebase-icon.svg" alt="fusebase icon" />
          </div>
          <div class="auth-form-title" *ngIf="viewType === 1 && !isShowTabs && authType !== NIM_AUTH_TYPE.REMOVE">Sign Up</div>
          <div class="auth-form-title" *ngIf="viewType === 2 && !isShowTabs && authType !== NIM_AUTH_TYPE.REMOVE">Want to create own pages and collaborate?</div>
          <div class="auth-form-title" *ngIf="authType === NIM_AUTH_TYPE.REMOVE">Want to remove this form?</div>

          <div class="auth-form-tabs" *ngIf="isShowTabs && !isChallengeActive">
            <div class="auth-form-tab "
                 [ngClass]="{'auth-form-tab__active': authType === NIM_AUTH_TYPE.SIGNUP}"
                 (click)="handleChangeAuthType(NIM_AUTH_TYPE.SIGNUP)"
                >Sign up</div>
            <div class="auth-form-tab"
                 [ngClass]="{'auth-form-tab__active': authType === NIM_AUTH_TYPE.SIGNIN}"
                 (click)="handleChangeAuthType(NIM_AUTH_TYPE.SIGNIN)"
                >Sign in</div>
          </div>
          <div class="auth-form-close" *ngIf="isShowClose" (click)="handleClose()">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M14.4053 4.65533C14.6982 4.36244 14.6982 3.88756 14.4053 3.59467C14.1124 3.30178 13.6376 3.30178 13.3447 3.59467L8.99527 7.94407L4.60808 3.63279C4.31264 3.34246 3.83779 3.34661 3.54746 3.64204C3.25713 3.93748 3.26128 4.41234 3.55672 4.70266L7.93457 9.00477L3.59467 13.3447C3.30178 13.6376 3.30178 14.1124 3.59467 14.4053C3.88756 14.6982 4.36244 14.6982 4.65533 14.4053L9.00449 10.0562L13.3914 14.3672C13.6869 14.6575 14.1617 14.6534 14.452 14.358C14.7424 14.0625 14.7382 13.5877 14.4428 13.2973L10.0652 8.99547L14.4053 4.65533Z" fill="black" fill-opacity="0.54"/>
            </svg>
          </div>
        </div>

        <div class="auth-form-subtitle" *ngIf="authType === NIM_AUTH_TYPE.REMOVE">Upgrade to FuseBase Standard today</div>
        <div class="auth-form-btn-wrapper" *ngIf="authType === NIM_AUTH_TYPE.REMOVE">
          <button class="btn-secondary" (click)="handleClose()">Keep the form</button>
          <button class="btn-icon" (click)="handleUpgrade()">
            <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M2.42085 7.41248C2.19305 7.18467 2.19305 6.81533 2.42085 6.58752L6.91735 2.30493C6.91743 2.30334 6.91751 2.30175 6.9176 2.30017L2.42085 6.58752L7.08752 1.92085C7.20005 1.80832 7.34713 1.75138 7.49461 1.75002C7.49641 1.75001 7.4982 1.75 7.5 1.75C7.50933 1.75 7.51866 1.75022 7.52798 1.75067C7.66781 1.75734 7.8057 1.81407 7.91248 1.92085L12.5791 6.58752C12.807 6.81533 12.807 7.18467 12.5791 7.41248C12.3513 7.64028 11.982 7.64028 11.7542 7.41248L8.08333 3.74162V11.6667C8.08333 11.9888 7.82217 12.25 7.5 12.25C7.17783 12.25 6.91667 11.9888 6.91667 11.6667V3.74162L3.24581 7.41248C3.01801 7.64028 2.64866 7.64028 2.42085 7.41248Z" fill="#F3F6FA"/>
            </svg>
            <span>
              Upgrade Today
            </span>
          </button>
        </div>

        <form *ngIf="authType !== NIM_AUTH_TYPE.REMOVE">
          <div class="auth-form-label" *ngIf="viewType === 2 && !isChallengeActive">Start your free account today:</div>

          <div class="auth-form-error" *ngIf="errorMessages.form">
            {{errorMessages.form}}
          </div>

          <div class="auth-form-controls" *ngIf="!isChallengeActive">
            <div class="auth-form-group" [ngClass]="{'auth-input-error': errorMessages.login}">
              <input type="email" [(ngModel)]="emailValue" (keyup)="handleLoginKeyUp($event)" name="email" placeholder="Email">
              <div class="auth-input-error_message" *ngIf="errorMessages.login">
                {{errorMessages.login}}
              </div>
            </div>

            <div class="auth-form-group" [ngClass]="{'auth-error': errorMessages.password}">
              <input type="password" [(ngModel)]="passwordValue" #passwordInput name="password" placeholder="Password">
              <div class="auth-input-error_message" *ngIf="errorMessages.password">
                {{errorMessages.password}}
              </div>
            </div>
          </div>

          <div class="auth-form-controls auth-form-controls__chalenge" *ngIf="isChallengeActive">
            <div class="auth-form-label" *ngIf="challengeValue.challengeType === 'otp'">Please enter your code</div>
            <div class="auth-form-label" *ngIf="challengeValue.challengeType=== 'captcha'">We detected a suspicious activity from your device, in order to continue please verify that you are a human by entering the text from the image below</div>
            <div class="auth-form-chllenge-image" *ngIf="challengeValue.challengeType=== 'captcha'">
              <img src="data:image/png;base64,{{challengeValue.image}}" alt="">
            </div>
            <div class="auth-form-group" [ngClass]="{'auth-input-error': errorMessages.challenge}">
              <input type="text" [(ngModel)]="challengeValue.answer" (keyup)="handleChallengeCodeKeyUp($event)" #codeInput name="challengeCode" placeholder="{{challengeValue.challengeType === 'otp' ? 'Code' : 'Text from the image'}}">
              <div class="auth-input-error_message" *ngIf="errorMessages.challenge">
                {{errorMessages.challenge}}
              </div>
            </div>
          </div>


          <div class="auth-form-group" *ngIf="authType === NIM_AUTH_TYPE.SIGNUP  && !isChallengeActive">
            <div class="auth-form-slogan">
              By clicking “Sign up”, you agree to our <a [href]="termsLink" (click)="handleOpenTermsLink($event)" class="href">Terms and Conditions</a>
            </div>
          </div>

          <div class="auth-form-group" *ngIf="isChallengeActive && challengeValue.challengeType === 'otp'">
            <div class="auth-form-slogan">
              Check your authentication app for code.
              <br>
              <a [href]="otpLink" (click)="handleOpenOtpLink($event)" class="href">Having trouble finding your code?</a>
            </div>
          </div>

          <div class="auth-form-group">
            <div class="auth-form-actions">
              <button (click)="submit()">
                <span *ngIf="authType === NIM_AUTH_TYPE.SIGNUP && !isChallengeActive">Sign up</span>
                <span *ngIf="authType === NIM_AUTH_TYPE.SIGNIN && !isChallengeActive">Sign in</span>
                <span *ngIf="isChallengeActive">Continue</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        font-family: 'Roboto', sans-serif;
      }

      :host * {
        box-sizing: border-box;
      }

      :host input {
        min-width: 100%;
        padding: 11px 10px;
        border-radius: 8px;
        border-style: solid;
        border-width: 1px;
        font-size: 14px;
        font-weight: 400;
        font-family: sans-serif;
        outline: none;
      }
      :host button {
        height: 38px;
        padding: 10px 30px;
        border: none;
        border-radius: 19px;
        background: rgba(0, 161, 183, 1);
        color: #FFF;
        font-size: 13px;
        font-weight: bold;
        transition: background-color .3s;
        cursor: pointer;
        display: flex;
        align-items: center;
      }
      :host button.btn-secondary{
        background: rgba(0, 161, 183, 0.1);
        color: #00A1B7;
      }
      :host button.btn-icon{
        padding: 10px 18px;
      }
      :host button svg{
        margin-right: 10px;
      }
      :host button:hover {
        background: rgba(7, 184, 199, 1);
      }
      :host button.btn-secondary:hover{
        color: #fff;
      }
      :host button:active {
        background: rgba(0, 128, 159, 1);
      }
      :host button:disabled{
        background: rgba(0, 0, 0, 0.12);
      }

      .href{
        color: #00ACC1;
        text-decoration: none;
      }

      .auth-form-wrapper {
        width: 300px;
        padding: 20px;
        border-radius: 10px;
        border-style: solid;
        border-width: 1px;
        box-shadow: 0px 8px 7px -4px rgba(0, 0, 0, 0.08),
                    0px 17px 12px 2px rgba(0, 0, 0, 0.08) !important;
      }

      .auth-form-controls .auth-form-label{
        margin-top: 15px;
      }

      .auth-form-chllenge-image{
        text-align: center;
        margin-top: 15px;
      }

      .auth-form-top{
        display: flex;
        margin-bottom: 20px;
      }

      .auth-form-logo{
        width: 18px;
        height: 18px;
        margin-right: 6px;
        align-self: center;

        img {
          height: 18px;
        }
      }

      .auth-form-close{
        width: 18px;
        height: 18px;
        cursor: pointer;
        margin-left: auto;
      }

      .auth-form-title {
        font-size: 24px;
        font-weight: 600;
      }

      .auth-form-subtitle{
        text-align: center;
        font-size: 13px;
        line-height: 18px;
      }

      .auth-form-tabs{
        display: flex;
      }

      .auth-form-tab{
        padding: 12px 28px;
        font-size: 18px;
        line-height: 24px;
        border-bottom: 2px solid transparent;
        font-weight: bold;
        cursor: pointer;
      }

      .auth-form-slogan {
        text-align: center;
        font-size: 14px;
        line-height: 20px;
      }

      .auth-form-group {
        margin-top: 20px;
      }

      .auth-form-error{
        text-align: center;
        color: #930000;
        background: #fff1f1;
        padding: 12px 15px;
        border-radius: 3px;
        font-size: 15px;
      }

      .auth-input-error_message{
        color: #aa0000;
        margin-top: 5px;
      }

      .auth-form-actions {
        display: flex;
        justify-content: center;
      }

      .auth-form-label{
        font-size: 13px;
        line-height: 18px;
      }

      .auth-form__disabled form {
        opacity: 0.3;
        pointer-events: none;
      }

      .auth-form-btn-wrapper{
        margin-top: 20px;
        display: flex;
        justify-content: space-around;
      }

      /* View Type 2 */
      .m-viewtype-2  .auth-form-wrapper {
        width: 500px;
        padding: 26px;
        box-shadow: none !important;
      }

      .m-viewtype-2 .auth-form-title {
        font-size: 18px;
        line-height: 24px;
      }

      .m-viewtype-2 .auth-form-close{
        margin-top: 3px;
      }

      .m-viewtype-2 .auth-form-controls{
        display: flex;
        margin-top: 8px;
      }

      .m-viewtype-2 .auth-form-controls .auth-form-group{
        margin-top: 0;
        width: 50%;
      }

      .m-viewtype-2 .auth-form-controls .auth-form-group:not(:last-child){
        margin-right: 20px;
      }

      .m-viewtype-2 .auth-form-slogan{
        text-align: left;
      }

      .m-viewtype-2 .auth-form-actions{
        text-align: left;
      }

      .m-viewtype-2 .auth-form-controls__chalenge{
        flex-direction: column;
      }

      .m-viewtype-2 .auth-form-controls__chalenge .auth-form-chllenge-image{
        margin-bottom: 10px;
      }

      .m-viewtype-2 .auth-form-controls__chalenge .auth-form-group{
        width: 100%;
      }

      /* REMOVE FORM */
      .auth-form__remove .auth-form-wrapper{
        width: 380px;
      }
      .auth-form__remove .auth-form-title{
        margin-left: auto;
        margin-right: auto;
      }
      .auth-form__remove .auth-form-close{
        margin-left: 0;
      }

      /* LIGHT THEME */
      :host-context(.nns-theme-day) .auth-form-wrapper {
        background: white;
        border-color: rgba(0, 0, 0, 0.14);
        color: rgba(0, 0, 0, 0.87)
      }
      :host-context(.nns-theme-day) .m-viewtype-2 .auth-form-wrapper {
        background: #F5F8FA;
        border: none;
      }
      :host-context(.nns-theme-day) input {
        background: white;
        border-color: rgba(0, 0, 0, 0.14);
      }
      :host-context(.nns-theme-day) input::placeholder {
        color: rgba(0, 0, 0, 0.54);
      }
      :host-context(.nns-theme-day) .auth-form-tab{
        color: rgba(0,0,0, .54);
      }
      :host-context(.nns-theme-day) .auth-form-tab__active{
        color: #00ACC1;
        border-color: #00ACC1;
      }
      :host-context(.nns-theme-day) .auth-input-error input{
        border-color: #aa0000;
      }



      /* DARK THEME */
      :host-context(.nns-theme-night) .auth-form-wrapper {
        background: #20252B;
        border-color: rgba(255, 255, 255, 0.14);
        color: rgba(255, 255, 255, 0.87)
      }
      :host-context(.nns-theme-night) input {
        background: #20252B;
        border-color: rgba(255, 255, 255, 0.14);
        color: rgba(255, 255, 255, 0.54);
      }
      :host-context(.nns-theme-night) input::placeholder {
        color: rgba(255, 255, 255, 0.54);
      }
      :host-context(.nns-theme-night) .auth-form-tab__active{
        color: #00a1b7;
        border-color: #00a1b7;
      }
      :host-context(.nns-theme-night) .auth-form-close svg path{
        fill: #A9B6BE;
      }
    `
  ]
})
export class NimWebshareAuthFormComponent implements OnInit {
  @Input() viewType: number = 1;
  @Input() isDisabled: boolean = false;
  @Input() isShowClose: boolean = false;
  @Input() isShowTabs: boolean = false;
  @Input() authType = NIM_AUTH_TYPE.SIGNUP;
  @Input() upgradeLink: string = '';
  @Input() termsLink: string = ';'
  @Input() otpLink: string = ';'
  @Input() authUrl: string = ';'

  @Output() nimClose = new EventEmitter<void>();
  @Output() nimAuthTypeChange = new EventEmitter<NIM_AUTH_TYPE>();
  @Output() nimSubmit = new EventEmitter<{ sessionId: string, id?: number }>();

  @ViewChild('passwordInput') passwordInputElement: ElementRef | undefined;
  @ViewChild('codeInput') codeInputElement: ElementRef | undefined;

  NIM_AUTH_TYPE = NIM_AUTH_TYPE;

  emailValue = '';
  passwordValue = '';

  challengeValue = {
    challengeType: 'otp',
    state: '',
    answer: '',
    image: '',
  }

  isChallengeActive = false;
  errorMessages = {
    login: '',
    password: '',
    form: '',
    challenge: ''
  }

  authErrorMessage = {
    loginRequired: 'Login is required',
    loginIncorrect: 'Please enter valid email',
    passwordRequired: 'Password is required',
    passwordMim: 'Password must be at least 8 characters long',
    loginWrongData: 'Wrong Login or Password',
    registrationWrongData: 'Registration failed',
    existedEmail: 'E-Mail is already taken',
    wrongCode: 'Wrong code',
    codeRequired: 'Code is required',
    codeOnlyNumbers: 'Code must contain only numbers',
    codeSixNumbers: 'Code must be exactly 6 numbers',
  }

  constructor(private api: NimAuthApiClientService) {
  }

  ngOnInit(): void {
  }

  submit(): void {
    this.errorMessages = {
      login: '',
      password: '',
      form: '',
      challenge: '',
    };

    if(this.isChallengeActive) {
      if(this.checkChallenge(this.challengeValue.answer)) {
        this.challenge();
      }
      return;
    }

    const login = this.emailValue.trim();
    const password = this.passwordValue.trim();

    if(this.checkForm(login, password, this.authType)) {
      if(this.authType === this.NIM_AUTH_TYPE.SIGNIN) {
        this.login();
      } else if(this.authType === this.NIM_AUTH_TYPE.SIGNUP) {
        this.register();
      }
    }
  }

  login() {
    this.api.login({login: this.emailValue, password: this.passwordValue}, this.authUrl).subscribe((result) => {
      if (result.sessionId) {
        this.nimSubmit.next(result);
      } else {
        this.handleErrorResponse(result);
      }
    })
  }

  register() {
    this.api.register({
      login: this.emailValue,
      password: this.passwordValue
    }, this.authUrl).subscribe((result) => {
      if (result.sessionId) {
        this.nimSubmit.next(result);
      } else {
        this.handleErrorResponse(result);
      }
    })
  }

  challenge() {
    this.api.challenge({state: this.challengeValue.state, answer: this.challengeValue.answer}, this.authUrl).subscribe((result) => {
      if(result.sessionId) {
        this.nimSubmit.next(result);
      } else {
        if(this.challengeValue.challengeType === 'captcha' && result.errorCode === 0) {
          this.isChallengeActive = false;
          this.challengeValue = {
            state: '',
            answer: '',
            challengeType: '',
            image: '',
          }
        } else {
          this.handleErrorResponse(result);
        }
      }
    })
  }

  handleErrorResponse(result: INimLoginResponse | INimRegisterResponse) {
    if(result.errorCode === -26) {
      if(this.isChallengeActive) {
        this.showFormError(NIM_AUTH_ERRORS.WRONG_CODE);
      } else {
        this.isChallengeActive = true;
      }

      setTimeout(() => {
        this.focusInput(this.codeInputElement);
      })
      this.challengeValue = {
        challengeType: result.body.challenge.type,
        state: result.body.challenge.state,
        answer: '',
        image: result.body.challenge.image,
      }
      return;
    }

    if(result.errorCode === -6 && this.isChallengeActive) {
      this.showFormError(NIM_AUTH_ERRORS.WRONG_CODE);
      this.focusInput(this.codeInputElement);
      return;
    }

    if(this.authType === NIM_AUTH_TYPE.SIGNUP) {
      if (result.errorCode === -4) {
        this.showFormError(NIM_AUTH_ERRORS.EXISTED_EMAIL);
      } else {
        this.showFormError(NIM_AUTH_ERRORS.REGISTRATION_WRONG_DATA);
      }
      return;
    } else {
      this.showFormError(NIM_AUTH_ERRORS.LOGIN_WRONG_DATA);
    }
  }

  focusInput(element: ElementRef | undefined) {
    if(element && element.nativeElement) {
      element.nativeElement.focus();
    }
  }


  checkForm(login: string, password: string, authType: number) {
    if(!login || !login.length) {
      this.showFormError(NIM_AUTH_ERRORS.LOGIN_REQUIRED);
      return false;
    }

    if(authType === NIM_AUTH_TYPE.SIGNUP) {
      if(!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(login)) {
        this.showFormError(NIM_AUTH_ERRORS.LOGIN_INCORRECT);
        return false;
      }
    }

    if(!password || !password.length) {
      this.showFormError(NIM_AUTH_ERRORS.PASSWORD_REQUIRED);
      return false;
    }

    if(authType === NIM_AUTH_TYPE.SIGNUP) {
      if(password.length < 8) {
        this.showFormError(NIM_AUTH_ERRORS.PASSWORD_MIN);
        return false;
      }
    }
    return true;
  }

  checkChallenge(code: string) {
    if(!code.length) {
      this.showFormError(NIM_AUTH_ERRORS.CODE_REQUIRED);
      return false;
    }
    if(this.challengeValue.challengeType === 'otp' && !/^\d+$/.test(code)) {
      this.showFormError(NIM_AUTH_ERRORS.CODE_ONLY_NUMBERS);
      return false;
    }
    if(this.challengeValue.challengeType === 'otp' && code.length != 6) {
      this.showFormError(NIM_AUTH_ERRORS.CODE_SIX_NUMBERS);
      return false;
    }

    return true;
  }

  validateEmail(value: string) {
    if(/-{2,}/.test(value)) {
      return false;
    }
    if(/^-/.test(value) || /-$/.test(value)) {
      return false;
    }
    return /^[a-z0-9-]+$/i.test(value);
  }

  showFormError(authErrorType: number) {
    switch (authErrorType) {
      case NIM_AUTH_ERRORS.LOGIN_REQUIRED: {
        this.errorMessages.login = this.authErrorMessage.loginRequired;
        break;
      }
      case NIM_AUTH_ERRORS.LOGIN_INCORRECT: {
        this.errorMessages.login = this.authErrorMessage.loginIncorrect;
        break;
      }
      case NIM_AUTH_ERRORS.PASSWORD_REQUIRED: {
        this.errorMessages.password = this.authErrorMessage.passwordRequired;
        break;
      }
      case NIM_AUTH_ERRORS.PASSWORD_MIN: {
        this.errorMessages.password = this.authErrorMessage.passwordMim;
        break;
      }
      case NIM_AUTH_ERRORS.LOGIN_WRONG_DATA: {
        this.errorMessages.form = this.authErrorMessage.loginWrongData;
        break;
      }
      case NIM_AUTH_ERRORS.REGISTRATION_WRONG_DATA: {
        this.errorMessages.form = this.authErrorMessage.registrationWrongData;
        break;
      }
      case NIM_AUTH_ERRORS.EXISTED_EMAIL: {
        this.errorMessages.form = this.authErrorMessage.existedEmail;
        break;
      }
      case NIM_AUTH_ERRORS.WRONG_CODE: {
        this.errorMessages.form = this.authErrorMessage.wrongCode;
        break;
      }
      case NIM_AUTH_ERRORS.CODE_REQUIRED: {
        this.errorMessages.challenge = this.authErrorMessage.codeRequired;
        break;
      }
      case NIM_AUTH_ERRORS.CODE_ONLY_NUMBERS: {
        this.errorMessages.challenge = this.authErrorMessage.codeOnlyNumbers;
        break;
      }
      case NIM_AUTH_ERRORS.CODE_SIX_NUMBERS: {
        this.errorMessages.challenge = this.authErrorMessage.codeSixNumbers;
        break;
      }
    }
  }

  handleLoginKeyUp(event: KeyboardEvent) {
    if(event.key === 'Enter') {
      event.preventDefault();
      if(!this.errorMessages.login.length && this.emailValue && this.emailValue.length && this.passwordInputElement) {
        this.passwordInputElement.nativeElement.focus();
      }
    } else {
      this.errorMessages.login = '';
    }
  }

  handlePasswordKeyUp(event: KeyboardEvent) {
    if(event.key != 'Enter') {
      this.errorMessages.password = '';
    }
  }

  handleChallengeCodeKeyUp(event: KeyboardEvent) {
    if(event.key != 'Enter') {
      this.errorMessages.challenge = '';
    }
  }

  handleClose() {
    this.cleanForm();
    this.nimClose.next();
  }

  handleChangeAuthType(authType: number) {
    this.nimAuthTypeChange.next(authType);
  }

  handleUpgrade() {
    window.open(this.upgradeLink, '_blank')
  }

  handleOpenTermsLink(event: MouseEvent) {
    event.preventDefault();
    window.open(this.termsLink, '_blank')
  }

  handleOpenOtpLink(event: MouseEvent) {
    event.preventDefault();
    window.open(this.otpLink, '_blank')
  }

  cleanForm() {
    this.emailValue = '';
    this.passwordValue = '';
    this.isChallengeActive = false;
    this.challengeValue = {
      state: '',
      answer: '',
      challengeType: '',
      image: '',
    }
    this.errorMessages = {
      login: '',
      password: '',
      form: '',
      challenge: ''
    }
  }
}
